import Image from "next/image";

export const OurStaff = () => (
  <div className="bg-primary-black pt-32 pb-20 px-4 md:py-20 md:px-10 xl:py-40">
    <div>
      <h2 className="text-4xl xl:text-6xl xl:leading-tight font-normal text-white pb-8 w-11/12 md:w-full xl:w-1/2">
        <span>Why choose our IT Staff Augmentation Service?</span>
      </h2>
      <p className="w-full text-base font-normal text-white md:w-11/12 xl:w-1/2">
        <span>
          Because when you choose to work with ultroNeous to fulfill your staff
          augmentation needs, you will get the benefit of the CURQ model which
          we strongly believe in.
        </span>
      </p>
    </div>
    <div className="pt-14 xl:pt-28 xl:pr-40 xl:pl-96">
      <div className="flex flex-col md:grid md:grid-cols-2 gap-y-14 md:gap-x-20 md:gap-y-24">
        <div>
          <Image
            alt="Cost"
            height={50}
            src={"/assets/services/staff-augmentation/staff-cost.webp"}
            title="Cost"
            width={50}
          />
          <h3 className="text-sm md:text-xl font-medium text-white py-4">
            Cost
          </h3>
          <p className="text-xs md:text-base font-light text-justify text-white">
            We understand that every requirement comes up with a budget. We
            provide dedicated resources who can fulfill your technical
            requirement, as well as who is fitting within the budget.
          </p>
        </div>
        <div>
          <Image
            alt="Understanding"
            height={50}
            src={"/assets/services/staff-augmentation/staff-understanding.webp"}
            title="Understanding"
            width={50}
          />
          <h3 className="text-sm md:text-xl font-medium text-white py-4">
            Understanding
          </h3>
          <p className="text-xs md:text-base font-light text-justify text-white">
            Reviewing the requirement and understanding the technicalities,
            expertise level, communication level and any additional notes given
            by you requires the experience which we carry.
          </p>
        </div>
        <div>
          <Image
            alt="Reliability"
            height={50}
            src={"/assets/services/staff-augmentation/staff-reliability.webp"}
            title="Reliability"
            width={50}
          />
          <h3 className="text-sm md:text-xl font-medium text-white py-4">
            Reliability
          </h3>
          <p className="text-xs md:text-base font-light text-justify text-white">
            We value you and your projects, and that is why the resources who
            work with you will make sure to follow all the working and reporting
            protocols. They will be your reliable outsourcing staff.
          </p>
        </div>
        <div>
          <Image
            alt="Quality"
            height={50}
            src={"/assets/services/staff-augmentation/staff-quality.webp"}
            title="Quality"
            width={50}
          />
          <h3 className="text-sm md:text-xl font-medium text-white py-4">
            Quality
          </h3>
          <p className="text-xs md:text-base font-light text-justify text-white">
            When you select the dedicated resources from our pool of experts,
            you are guaranteed to get the best quality work which will escalate
            the progress of your project and get results.
          </p>
        </div>
      </div>
    </div>
  </div>
);
export default OurStaff;
